import React, { useState, useEffect, Fragment } from 'react';
import { PageHeader, Card, Typography, Tag, Button, Spin, Carousel, Divider, Skeleton } from 'antd';
import { ClockCircleFilled } from '@ant-design/icons';
import './../../styles/components/MarketPlace/JobListings.scss';
import JobCard from './JobCard';
import { useHistory, useLocation } from 'react-router-dom';
import { getJobs } from '../../services/API/MarketplaceService';
import ScreenNavigation from './ScreenNavigation';
import { Navigation } from '../../services/NavigationService';
import { Routes } from '../../constants/RouterConstants';
import AppliedJobsCard from './AppliedJobsCard';
import useMoengage from '../../hooks/useMoengage';
import { useMitraStore } from '../../contexts/MitraContext';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import JobListingsSkeleton from './skeletons/JobListingsSkeleton';
import ReusableCarousel from './ReusableCarousel';
import { jobListingPageTopCarousel } from '../../constants/MarketplaceConstants';
import ReusableReviewComponent from './ReusableReviewComponent';
import { jobListingPageTestimonials } from '../../constants/MarketplaceConstants';
import jd_testimonial from '../../assets/jd_testimonial.svg';
import { MARKETPLACE_CONSTANTS } from '../../constants/MarketplaceConstants';

const { Text } = Typography;

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const JobListings = () => {
  const history = useHistory();
  const [jobs, setJobs] = useState([]);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [comingSoonJobs, setComingSoonJobs] = useState([]);
  const [unavailableJobs, setUnavailableJobs] = useState([]);
  let query = useQuery();
  const selectedCity = query.get('city');
  const [loading, setLoading] = useState(true);
  const [, trackEvent] = useMoengage();
  const { selectedMitraDetails } = useMitraStore();
  const [reachedBottom, setReachedBottom] = useState(false);
  const { t, i18n } = useTranslation();

  function scrollBottom() {
    // Get the total height of the document
    const totalHeight = document.body.scrollHeight;

    // Get the current position of the scroll bar
    const currentPosition = window.innerHeight + window.scrollY;

    // Compare the current position to the total height
    if (currentPosition >= totalHeight) {
      setReachedBottom(true);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollBottom);
    trackEvent('jse_viewed_job_listings', {
      userId: localStorage.getItem('userId'),
      userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
      timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
    const userId = localStorage.getItem('userId');
    setLoading(true);
    getJobs(`"${selectedCity}"`, '', userId)
      .then(response => {
        setLoading(false);
        setJobs([...response.data.viewData.allJobDemands.otherJobDemands] || []);
        setAppliedJobs([...response.data.viewData.allJobDemands.appliedJobDemands] || []);
        setComingSoonJobs([...response.data.viewData.allJobDemands.comingSoonJobs] || []);
        setUnavailableJobs([...response.data.viewData.allJobDemands.unavailableJobs] || []);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }, []);

  useEffect(() => {
    return () => {
      if (reachedBottom) {
        trackEvent('jse_scrolled_to_bottom_job_listings', {
          userId: localStorage.getItem('userId'),
          userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
          timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
        });
      }
    };
  });

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title={t('job_listings_header')}
        extra={[
          <div className="header-city-content">
            <Text className="city-name-header">
              <img src="/images/location-icon.png" /> {selectedCity}
            </Text>
            <Text
              className="change-city-header"
              onClick={() => {
                // history.replace('/jobs/select-city');
                trackEvent('jse_job_listings_change_city_clicked', {
                  userId: localStorage.getItem('userId'),
                  userPhoneNumber: selectedMitraDetails?.userPhoneNumber,
                  timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
                });
                const route = {
                  pathname: Routes.SELECT_CITY_WISE_JOBS,
                };
                Navigation.push(route);
              }}
            >
              {t('change_city')}
            </Text>
          </div>,
        ]}
      />
      <div
        className="job-listings-main-container"
        style={
          appliedJobs.length > 0 && jobs.length === 0
            ? { background: '#FFFFFF' }
            : appliedJobs.length > 0
            ? { background: '#F2F2F2' }
            : null
        }
      >
        {/* <Spin spinning={loading} className='spinner' tip={"Loading"} /> */}
        {/* <div className="total-jobs-container">
          {`${jobs.length+appliedJobs.length} Job(s) Found, `} {`${appliedJobs.length} Applied`}
          </div> */}
        <div className="individual-job-listing">
          {loading
            ? [...Array(3)].map((val, index) => {
                return <JobListingsSkeleton key={index} />;
              })
            : null}

          <ReusableCarousel carouselProps={jobListingPageTopCarousel} currentCity={selectedCity} />

          {appliedJobs.length > 0 && (
            <div className="applied-jobs-container">
              <img
                src="/images/applied-jobs-indicator.png"
                style={{ width: '128px', paddingTop: '24px' }}
              ></img>
              {/* <div style={{display:'flex', overflow:'scroll',justifyContent: appliedJobs.length===1 ? "center":null}}> */}
              <Carousel slidesToShow={1.15} infinite={false}>
                {// for applied jobs
                appliedJobs.length
                  ? appliedJobs.map(job => {
                      return <AppliedJobsCard key={job.id} jobData={job} city={selectedCity} />;
                    })
                  : null}
              </Carousel>
              {/* </div> */}
            </div>
          )}

          {jobs.length ? (
            <div className="available-jobs-container">
              {// for available jobs
              jobs.length
                ? jobs.map((job, index) => (
                    <div className="jobs-review-container">
                      <Fragment>
                        <JobCard key={job.id} jobData={job} city={selectedCity} jobIndex={index}/>
                      </Fragment>
                    </div>
                  ))
                : null}
            </div>
            ) : null
          }
          

          {
            comingSoonJobs.length ? (
              <>
                <div className='unavailable-jobs-highlighter coming-soon-jobs-highlighter'>
                  <Text className='coming-soon-job-text'>Coming Soon</Text>
                </div>
                <div className='coming-soon-jobs-container'>
                  {
                    comingSoonJobs.length ? comingSoonJobs.map((job) => {
                      return (
                      <JobCard key={job.id} jobData={job} city={selectedCity} jobType='comingSoon' showCTA={false}/>
                      )
                    }) : null
                  }
                </div>
              </>
            ): null
          }
          

          {
            unavailableJobs.length ? (
              <>
                <div className='unavailable-jobs-highlighter'>
                  <Text className='unavailable-job-text'>Unavailable Jobs</Text>
                </div>
                <div className='coming-soon-jobs-container'>
                  {
                    unavailableJobs.length ? unavailableJobs.map((job) => {
                      return (
                      <JobCard key={job.id} jobData={job} city={selectedCity} jobType='unavailable' showCTA={false}/>
                      )
                    }) : null
                  }
                </div>
              </>
            ): null
          }

          {
            // if jobs not available for a city and no job(s) already applied in that city
            !jobs.length && !appliedJobs.length && !unavailableJobs.length && !comingSoonJobs.length ? (
              !loading && <div className='no-jobs-container'>
                <img src='/images/no-jobs.png' />
                <Text className='no-jobs-text'>No jobs available in <br /> the selected City</Text>
                </div>
              )
            : null}
        </div>
      </div>
      {/* {
        !jobs.length && appliedJobs.length ? (
          !loading && <div className='no-available-jobs-container'>
            <img src='/images/no-jobs.png' />
            <Text className='no-jobs-text'>No new jobs available in <br /> the selected city.</Text>
          </div>
        ): null
        } */}
      {MARKETPLACE_CONSTANTS?.NAVIGATION_ITEMS?.length > 1 ? <ScreenNavigation /> : null}
    </div>
  );
};

export default JobListings;
